export default __webpack_public_path__ + "static/media/project1image2.c8dbdf82.png";